import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Proveedor } from '../../../models/Proveedor';
import { ApiAuthService } from '../../../services/api-auth.service';
import { ApiUploadFileService } from '../../../services/api-upload-file.service';
import { ApiDownloadFileService } from '../../../services/api-download-file.service';
import { ApiRegistryService } from '../../../services/api-registry.service';
import { ApiParametrosService } from '../../../services/api-parametros.service';
import { Globals } from '../../../globals';


declare var $: any;

@Component({
  selector: 'app-registro-docsarch',
  templateUrl: './registro-docsarch.component.html',
  styleUrls: ['./registro-docsarch.component.css']
})
export class RegistroDocsarchComponent implements OnInit {

  registros: any [] = [];
  pk_proveedor: string = '';
  vpnGoddocs: string = '';
  comentarios: string = '';

  public files: FileList; // Variable para guardar el archivo que se va a cargar
  public vpnMov; //Movimiento a realizar -> 1 - Guardar. 2 - Eliminar
  public vpsTipoProv; //Tipo de proveedor
  public vpsCveDoc; //Clave del documento
  public cveReporteSol: string; //Clave del reporte de solicitud que se puede imprimir
  public cveReporCons: string; //Clave del reporte de constancia que se puede imprimir

  public mensajeAlerta: string = ''; //Mensaje que se muestra en el modal de alerta
  public mensajeExito: string = ''; //Mensaje que se muestra en el modal de exito
  public tipoAlerta: number; //Indicador del modal de alerta, segun la opción correspondiente -> 0-Eliminar Archivo. 1-Finalizar proceso. 3-Alerta.
  public tipoMov: number = 0; //Guarda el movimiento que se hizo, guardar-eliminar archivo o finalizar proceso, para recargar o redirigir a otro componente dependiendo del movimiento.
  public bloqueaNoActiv: number = 0; //Variable para el comportamiento de la pagina, mostrar y ocultar botones, si el estado del proveedor ya esta en captura finalizada.
  public estado: string;
  public cveProvedor: string = ''; //Guarda la clave del proveedor

  public PK_TIPO_PROVEEDOR: string = '';
  public etiquetaTitulo: string = 'Pre-registro de Proveedores, Contratistas y Prestadores de Servicio'; //Titulo principal de la pagina

  public mensajeError: string = '';//Mensaje que se muestra en el modal de error
  public error: number; //Guardar el estatus del error cuando se presenta uno.
  requiredFileType:string = ".pdf, image/jpeg, image/png";
  public indtip:string = '0';
  @Input() public titulo: number; //Variable para controlar el titulo de la pagina
  @ViewChild('myInput', {static: false}) myInput: ElementRef; //Controla el input file
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef; //Propiedad para la descarga de un archivo
  constructor(private router: Router, private apiRegistry: ApiRegistryService, private apiAuth: ApiAuthService,
              private apiUpload: ApiUploadFileService, private apiDownload: ApiDownloadFileService,
              public globals: Globals) { }

  ngOnInit() {
    if (this.titulo === 1){
      this.etiquetaTitulo = 'Perfil';
    }
    $('#mod_procesando').modal('show');
    this.getInfoProv();
  }

  //Obtiene la plantilla que se muestra en la tabla
  getPlantillaDoc() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();//Decodifica token
    this.estado = proveedor.Tipo;//Estado del proveedor
    this.indtip = proveedor.TipoProv;

    this.apiRegistry.getPlantillaDoc(proveedor.Correo, this.pk_proveedor).subscribe(data => {
      if (data[0].success) {
        if (data[0].info !== '{}'  && data[0].info !== '[]') {
          let datos = data[0].info;
          datos = JSON.parse(datos);
          this.registros = datos;
          $(document).ready(function() {
            $('[data-toggle="tooltip"]').tooltip();
          });
          this.noActivo();//Checar si esta en NO ACTIVO
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
         }, 500);
        } else {
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
         }, 500);
        }
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
    },
    error => {
      this.error = error.status;
      //Error 401, token esta caducado
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Obtiene la información del proveedor
  getInfoProv() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded(); //Decodifica token
    this.indtip = proveedor.TipoProv;

    this.apiRegistry.getInformacionRfc(proveedor.RFC).subscribe(data => {
      if (data[0].success) {
        if (data[0].info !== '{}' && data[0].info !== '[]') {
          let datos = data[0].info;
          datos = JSON.parse(datos);
          this.cveProvedor = datos[0].CLAVEPROV;
          this.pk_proveedor = datos[0].PK_FKCPRCO;
          this.cveReporteSol = datos[0].CVESOLINSC;//Cve reporte solicitud
          this.cveReporCons = datos[0].CVECONSTA;//Cve reporte constancia
          this.PK_TIPO_PROVEEDOR = datos[0].PK_TIPO_PROVEEDOR;
          if(this.PK_TIPO_PROVEEDOR === '4'){
            this.requiredFileType = 'application/pdf, image/jpg, image/jpeg, image/png';
          }else{
            this.requiredFileType = '*';
          }
          this.getPlantillaDoc();//Obtener plantilla de los documentos
        } else {
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
         }, 500);
        }
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
    },
    error => {
      this.error = error.status;
      //Error 401, token esta caducado
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Al detectar el change en el input file.
  cargarArchivo(files: FileList) {
    console.log("File: "+files[0].type);
    if(this.PK_TIPO_PROVEEDOR === '4'){
      if(files[0].type === "application/pdf" || files[0].type === "image/jpeg" || files[0].type === "image/jpg" || files[0].type === "image/png"){
        this.files = files;//Asigna el archivo que se seleccionó en el input file a la variable files.
      }else{///Quitar el documento
        this.myInput.nativeElement.value = '';
      }
    }else{
      this.files = files;//Asigna el archivo que se seleccionó en el input file a la variable files.
    }
  }


  //Guardar archivo
  guardarArchivo() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();//Decodifica el token
    //Si hay archivos seleccionados
    if (this.files !== undefined && this.files.length > 0) {
        $('#mod_procesando').modal('show');
        this.apiUpload.postFile(proveedor.Correo,this.vpnMov,this.pk_proveedor,this.vpsTipoProv,this.vpsCveDoc,this.vpnGoddocs,this.comentarios,this.files[0]).subscribe(data => {
          if (data[0].success) {
            this.tipoMov = 0;
            setTimeout( () => {
              this.mensajeExito = '¡El documento ha sido cargado correctamente!';
              $('#mod_procesando').modal('hide');
              $('#success_exito').modal('show');
            },500);
          } else {
            this.mensajeError = data[0].msgRespuesta;
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
           }, 500);
          }
        },
        error => {
          this.error = error.status;
          //Error 401, token esta caducado
          if (error.status === 401) {
            this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
          } else  {
            this.mensajeError = '¡Error!';
          }
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        });
  } else {
    $('#info').modal('show');
  }
  }

  //Eliminar Archivo
  eliminarArchivo() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();//Decodifica el token
    $('#mod_procesando').modal('show');
    this.apiUpload.deleteFile(proveedor.Correo,this.vpnMov,this.pk_proveedor,this.vpsTipoProv,this.vpsCveDoc,this.vpnGoddocs).subscribe(data => {
      if (data[0].success) {
        this.tipoMov = 0;
        setTimeout( () => {
          this.mensajeExito = '¡El documento ha sido eliminado correctamente!';
          $('#mod_procesando').modal('hide');
          $('#success_exito').modal('show');
        },500);
      } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
           }, 500);
      }
    },
    error => {
      this.error = error.status;
      //Error 401, token esta caducado
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Asigna los valores a las variables correspondientes, para realizar guardado o eliminado de archivos.
  arch(mov: string, cvedoc: string, goddocs: string, tipodocto: string) {
    this.myInput.nativeElement.value = ''; //Limpia el input file
    this.comentarios = '', //Limpia los comentarios
    this.vpnMov = mov;
    this.vpsCveDoc = cvedoc;
    this.vpnGoddocs = goddocs;
    this.vpsTipoProv = tipodocto;
    this.mensajeAlerta = '¿Estás seguro que desea eliminar el documento?';
    this.tipoAlerta = 0;
  }


  //Revisa que todos los documentos obligatorios esten cargados, en caso contrario se mostrara una alerta con el mensaje correspondiente.
  finalizar() {
    let bandValida = true;
    for (let i =0; i<this.registros.length; i++) {
      //Si el documento es oblitario y no esta cargado, mostrara mensaje de alerta
      if (this.registros[i].OBLIGATORIO === '1') {
        if (this.registros[i].DOCCARGADO === '') {
          bandValida = false;
        }
        if (this.estado === this.globals.ESTATUS_REFRENDO){
          if (this.registros[i].DOCREFRENDO === '1' && this.registros[i].REFCOMP === '0'){
            bandValida = false;
          }
        }
      }
    }

    if (bandValida === false){
      this.tipoAlerta = 3;
      if(this.estado !== this.globals.ESTATUS_REFRENDO){
        this.mensajeAlerta = 'Es necesario cargar todos los archivos pertinentes para completar el proceso.';
      }else{
        this.mensajeAlerta = 'Debe actualizar el documento marcado en rojo para poder completar su proceso.';
      }

    } else {
      this.tipoAlerta = 1;

      if(this.estado !== this.globals.ESTATUS_REFRENDO){
        this.mensajeAlerta = 'Recuerde que una vez finalizada, no podrá realizar modificaciones ¿Está seguro que desea finalizar el proceso de Pre-Registro?.';
      }else{
        this.mensajeAlerta = 'Recuerde que una vez finalizada, no podrá realizar modificaciones ¿Está seguro que desea finalizar?.';
      }
    }
  }

  //Finaliza el proceso, cuando ya se han cargado todos los documentos obligatorios
  finalizarProceso() {
    console.log('Finalizar proceso');
    $('#mod_procesando').modal('show');
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();//Decodifica el token

    //Llamada para finalizar el proceso
    this.apiRegistry.finalizaCaptura(this.pk_proveedor, proveedor.Correo).subscribe(data => {
      if (data[0].success) {
        this.tipoMov = 1;
        setTimeout( () => {
          if(this.estado !== this.globals.ESTATUS_REFRENDO){
            this.mensajeExito = '¡El preregistro se realizó exitosamente!';
          }else{
            this.mensajeExito = '¡Refrendo completado!';
          }
          $('#mod_procesando').modal('hide');
          $('#success_exito').modal('show');
        }, 500);
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout( () => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      //Error 401, token esta caducado
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout( () => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  //Recargar al plantilla de los documentos(tabla).
  recargar() {
    this.getPlantillaDoc();
  }

  //Muestra modal de exito, despues de finalizar el proceso
  exito() {

    if(this.estado !== this.globals.ESTATUS_REFRENDO){
      $('#success').modal('show');
    }else{
      $('#success_refrendo').modal('show');
    }

  }

  descargaArchivo(cvedoc: string, nombre: string) {
    this.apiDownload.downloadFile(cvedoc).subscribe( result => {
      let url = window.URL.createObjectURL(result);

      const link = this.downloadLink.nativeElement;
      link.href = url;
      link.download = nombre;
      link.click();

      window.URL.revokeObjectURL(url);
    });
  }

  imprimirConstancia() {
    window.open(this.globals.BASE_URL_REPORTE + `ViewerExt.aspx?cverep=${ this.cveReporCons }`, '_blank');
  }

  imprimirSolicitud() {
    window.open(this.globals.BASE_URL_REPORTE + `ViewerExt.aspx?cverep=${ this.cveReporteSol }`, '_blank');
  }


  reemplazaCaracter(evento) {
    let cadena = evento.target.value;
    cadena = cadena.replace(/["/\\]/g, '');
    cadena = cadena.replace(/[&\\]/g, ' and ');
    evento.target.value = cadena;
    this.comentarios = cadena;
  }

  noActivo() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    if (proveedor.Tipo === '1' || proveedor.Tipo === '2' || proveedor.Tipo === '3') {
      this.bloqueaNoActiv = 1;
    } else {
      this.bloqueaNoActiv = 0;
    }
  }

  cerrarSesion() {
    this.apiAuth.deleteToken();
    this.router.navigate(['/']).then(() => window.location.reload());
  }

}
